module.exports = __webpack_public_path__ + "static/media/chatLogo2.75addd51.png";